import {
  BreadTransaction,
  CategoryType,
  FirestoreDocCategory,
} from "breadcommon";

/** The category types that get a color of their own in charts. */
export type ColoredCategoryType = "expenses" | "income" | "savings";

export const COLORED_TYPE_BY_CATEGORY_TYPE: Partial<
  Record<CategoryType, ColoredCategoryType>
> = {
  [CategoryType.Expense]: "expenses",
  [CategoryType.Income]: "income",
  [CategoryType.Savings]: "savings",
};

/**
 * Which type's color a category group is drawn in, following budget
 * tracking's rule. Groups can mix category types: a single-type group takes
 * its type's color; a mixed group is expenses-colored when it nets negative,
 * and otherwise income- or savings-colored, whichever brought in more. Null
 * when there's nothing to draw.
 */
export function categoryGroupColor(
  categories: FirestoreDocCategory[],
  net: number,
  transactions: BreadTransaction[],
): ColoredCategoryType | null {
  const types = new Set(categories.map((category) => category.type));
  if (types.size === 1) {
    return COLORED_TYPE_BY_CATEGORY_TYPE[categories[0].type] ?? null;
  }
  if (net === 0) return null;
  if (net < 0) return "expenses";

  const typeById = new Map(categories.map((c) => [c.id, c.type]));
  let incomeIn = 0;
  let savingsIn = 0;
  transactions.forEach((transaction) => {
    if (transaction.amount <= 0 || !transaction.categoryId) return;
    const type = typeById.get(transaction.categoryId);
    if (type === CategoryType.Income) incomeIn += transaction.amount;
    if (type === CategoryType.Savings) savingsIn += transaction.amount;
  });
  return incomeIn >= savingsIn ? "income" : "savings";
}
